import { LowerCaseSearchLanguage } from '@models/CountriesAndLanguages';
import LayoutEntityAvailability from '@models/LayoutEntityAvailability';

export const MenuItemTypes = ['page', 'menu', 'link', 'unmanaged'] as const;
export type MenuItemType = (typeof MenuItemTypes)[number];

export enum LinkBehavior {
  STANDARD = 'standard',
  EXTERNAL_STREAMING_SERVICE = 'external-streaming-service',
}

export enum LinkCondition {
  FREE = 'free',
  HIDDEN = 'hidden',
  UNMANAGED = 'unmanaged',
}

export type LinkParams = {
  behavior?: LinkBehavior;
  condition?: LinkCondition;
  linkTitle?: string;
  providerIdentifier?: string;
  url: string;
};

export type MenuItemUnmanagedParams = {
  action: string;
};

export type MenuItemParams =
  /**
   * For adding custom key-value pairs
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Record<string, any> & Partial<LinkParams> & Partial<MenuItemUnmanagedParams>;

type MenuItem = LayoutEntityAvailability & {
  uiId?: string;
  /**
   * String containing one character (displayed in icon fonts on clients)
   */
  icon?: string;
  /**
   * Editorial image path
   */
  image?: string;
  /**
   * For pages or unmanaged items in root menus
   */
  isRootItem?: boolean;
  label: Record<LowerCaseSearchLanguage, string>;
  /**
   * Only for link items
   */
  params?: MenuItemParams;
  /**
   * Leave empty for all menu item types except `unmanaged`
   */
  slug?: string;
  sourceId: string;
  type: MenuItemType;
};

export default MenuItem;
